import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccessService {
  userPermissions: Array<UserPermissions> = [];

  hasPermission(permission?: UserPermissions) {
    if (!permission) {
      return true;
    }

    const hasPermission = this.userPermissions.includes(permission);

    return hasPermission;
  }

  removeUserPermissions() {
    this.userPermissions = [];
  }

  addUserPermission(permission: UserPermissions) {
    this.userPermissions.push(permission);
  }
}

export type UserPermissions = 'ADMIN' | 'USER';
